import { defineMessages, IntlShape } from "react-intl";

enum LocationPeriod {
  LAST_24_HOURS,
  LAST_48_HOURS,
  LAST_7_DAYS,
  LAST_30_DAYS,
  LAST_60_DAYS,
  LAST_90_DAYS,
  CUSTOM,
}

const daysInPeriod = {
  [LocationPeriod.CUSTOM]: 0,
  [LocationPeriod.LAST_24_HOURS]: 1,
  [LocationPeriod.LAST_30_DAYS]: 30,
  [LocationPeriod.LAST_48_HOURS]: 2,
  [LocationPeriod.LAST_60_DAYS]: 60,
  [LocationPeriod.LAST_7_DAYS]: 7,
  [LocationPeriod.LAST_90_DAYS]: 90,
};
export const getDaysOffsetByLocationPeriod = (period: LocationPeriod): number =>
  daysInPeriod[period];

const messages = defineMessages({
  [LocationPeriod.CUSTOM]: {
    id: "map.layer.userLocation.filter.custom",
    defaultMessage: "Custom",
    description: "User location layer filter - Custom",
  },
  [LocationPeriod.LAST_24_HOURS]: {
    id: "map.layer.userLocation.filter.last24Hours",
    defaultMessage: "Last 24 Hours",
    description: "User location layer filter - Last 24 Hours",
  },
  [LocationPeriod.LAST_30_DAYS]: {
    id: "map.layer.userLocation.filter.last30Days",
    defaultMessage: "Last 30 Days",
    description: "User location layer filter - Last 30 Days",
  },
  [LocationPeriod.LAST_48_HOURS]: {
    id: "map.layer.userLocation.filter.last48Hours",
    defaultMessage: "Last 48 Hours",
    description: "User location layer filter - Last 48 Hours",
  },
  [LocationPeriod.LAST_60_DAYS]: {
    id: "map.layer.userLocation.filter.last60Days",
    defaultMessage: "Last 60 Days",
    description: "User location layer filter - Last 60 Days",
  },
  [LocationPeriod.LAST_7_DAYS]: {
    id: "map.layer.userLocation.filter.last7Days",
    defaultMessage: "Last 7 Days",
    description: "User location layer filter - Last 7 Days",
  },
  [LocationPeriod.LAST_90_DAYS]: {
    id: "map.layer.userLocation.filter.last90Days",
    defaultMessage: "Last 90 Days",
    description: "User location layer filter - Last 90 Days",
  },
});

export const getUserLocationPeriodDisplayName = (intl: IntlShape, period: LocationPeriod) =>
  intl.formatMessage(messages[period]);

export default LocationPeriod;
